/**
 * Whether a guided flow is on screen (release 17 review M-4): every WizardFrame step (Tambah umat,
 * Pendaftaran's desk flow, Paroki baru, Tambah orang) holds it while mounted, and ./db tells the
 * worker (`sync:alur`), whose sync loop then waits longer before it sends a save, so a value typed
 * wrong and corrected a moment later travels once. A flow moves from step to step by unmounting
 * one frame and mounting the next: the close is told only after `JEDA_TUTUP_MS` with no frame on
 * screen, so a step change never sends the flow's saves halfway. No React, no database: the
 * frames and the client meet here.
 */

/** How long no step may be on screen before the flow counts as closed. */
export const JEDA_TUTUP_MS = 1_000

let jumlah = 0
let terbuka = false
let tutupTimer: ReturnType<typeof setTimeout> | null = null
const pendengar = new Set<(terbuka: boolean) => void>()

function kabari(nilai: boolean): void {
  if (terbuka === nilai) return
  terbuka = nilai
  for (const fn of pendengar) fn(nilai)
}

/** A step is on screen; the returned function, called once, says it left. */
export function bukaAlur(): () => void {
  jumlah += 1
  if (tutupTimer !== null) {
    clearTimeout(tutupTimer)
    tutupTimer = null
  }
  kabari(true)
  let dilepas = false
  return () => {
    if (dilepas) return
    dilepas = true
    jumlah -= 1
    if (jumlah > 0) return
    tutupTimer = setTimeout(() => {
      tutupTimer = null
      if (jumlah === 0) kabari(false)
    }, JEDA_TUTUP_MS)
  }
}

/** Whether a flow counts as open now. */
export function alurTerbuka(): boolean {
  return terbuka
}

/** Calls `fn` at every open and close, and at once when a flow is open already. */
export function pantauAlur(fn: (terbuka: boolean) => void): () => void {
  pendengar.add(fn)
  if (terbuka) fn(true)
  return () => {
    pendengar.delete(fn)
  }
}
